import { render, staticRenderFns } from "./OutbrineBase.vue?vue&type=template&id=1537ec14&scoped=true"
import script from "./OutbrineBase.vue?vue&type=script&lang=js"
export * from "./OutbrineBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537ec14",
  null
  
)

export default component.exports